import {
  INTEGRATION_FUNCTIONS_REQUEST,
  INTEGRATION_FUNCTIONS_SUCCESS,
  INTEGRATION_FUNCTIONS_FAILURE,
  INTEGRATION_FUNCTIONS_UPDATE,
  INTEGRATION_SYNC_REQUEST,
  INTEGRATION_SYNC_SUCCESS,
  INTEGRATION_SYNC_FAILURE,
  UPDATE_FUNCTION_BY_ID_SUCCESS,
} from '../actions/integration-functions';
import { SELECT_ORGANISATION } from '../../organisation/actions';
import type { FunctionGroup } from '../actions/integration-functions';

export type IntegrationFunctionsState = {
  loading: boolean;
  error: string | null;
  data: FunctionGroup[];
  syncing: boolean;
  syncError: string | null;
};

const initialState: IntegrationFunctionsState = {
  loading: false,
  error: null,
  data: [],
  syncing: false,
  syncError: null,
};

export default (state = initialState, action: any): IntegrationFunctionsState => {
  switch (action.type) {
    case INTEGRATION_FUNCTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case INTEGRATION_FUNCTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data,
      };

    case INTEGRATION_FUNCTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case INTEGRATION_FUNCTIONS_UPDATE:
      return {
        ...state,
        data: action.data,
      };

    case INTEGRATION_SYNC_REQUEST:
      return {
        ...state,
        syncing: true,
        syncError: null,
      };

    case INTEGRATION_SYNC_SUCCESS:
      return {
        ...state,
        syncing: false,
        syncError: null,
      };

    case INTEGRATION_SYNC_FAILURE:
      return {
        ...state,
        syncing: false,
        syncError: action.error,
      };

    case UPDATE_FUNCTION_BY_ID_SUCCESS:
      return {
        ...state,
        data: state.data.map((group) => {
          const updatedLinkedWith = group.linked_with.map((func) => {
            if (func.id === action.data.id) {
              return {
                ...func,
                external_id: action.data.external_id,
              };
            }
            return func;
          });

          return {
            ...group,
            linked_with: updatedLinkedWith,
          };
        }),
      };

    case SELECT_ORGANISATION:
      return initialState;

    default:
      return state;
  }
};
